import toast from 'react-hot-toast';
import { createElement } from 'react';
import { UnifiedToast, type ToastVariant } from '@/components/ui/UnifiedToast';
import { getToastDescription } from './toast-descriptions';

export interface ShowToastOptions {
  toasterId?: string;
  variant: ToastVariant;
  title: string;
  description?: string;
  categoryLabel?: string;
  icon?: React.ReactNode;
  accentColor?: string;
  avatar?: string;
  sender?: string;
  actionLabel?: string;
  onAction?: () => void;
  onClick?: () => void;
  showCloseButton?: boolean;
  duration?: number;
  id?: string;
  position?: 'top-left' | 'top-center' | 'top-right' | 'bottom-left' | 'bottom-center' | 'bottom-right';
}

const DEFAULT_DURATIONS: Record<ToastVariant, number> = {
  success: 4000,
  error: 6000,
  info: 4000,
  warning: 5000,
  loading: Infinity,
  message: 5000,
  achievement: 5000,
};

export function showUnifiedToast(options: ShowToastOptions): string {
  const {
    variant,
    title,
    description: explicitDescription,
    categoryLabel,
    icon,
    accentColor,
    avatar,
    sender,
    actionLabel,
    onAction,
    onClick,
    showCloseButton,
    duration,
    id,
    position,
    toasterId,
  } = options;

  // Auto-lookup description from registry if none explicitly provided
  const description = explicitDescription || getToastDescription(title);

  return toast.custom(
    (t) =>
      createElement(UnifiedToast, {
        t,
        variant,
        title,
        description,
        categoryLabel,
        icon,
        accentColor,
        avatar,
        sender,
        actionLabel,
        onAction,
        onClick,
        showCloseButton,
      }),
    {
      duration: duration ?? DEFAULT_DURATIONS[variant],
      id,
      position: position ?? 'bottom-right',
      toasterId,
    }
  );
}
